export enum HistoricalDataMode {
  HISTORICAL = 'HISTORICAL',
  COMBINED = 'COMBINED',
  FORECAST = 'FORECAST',
}
